export default "__VITE_ASSET__BwTQAoG7__"